//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex'
import QuizResults from '~/mixins/quiz-results/quiz-results'
import CartSidebarPaynowPaymentMethod from '~/mixins/stripe/paynow/cart-sidebar'
import PageMixin from '~/mixins/page'
import GAEcommerce from '~/mixins/ga-ecommerce'
import IntercomMixin from '~/mixins/intercom'
import { GOALS_URL_PARAMS } from '~/constants/goalsData'

export default {
  mixins: [
    QuizResults,
    CartSidebarPaynowPaymentMethod,
    PageMixin,
    GAEcommerce,
    IntercomMixin
  ],
  data () {
    return {
      goal: this.$route.params.goal,
      goalNameParam: '', // superfluous ?
      area: null, // superfluous ?
      score: -1, // set based on goal
      starterTestIdParam: -1, // set onCreate
      plan: 'base-improvement-plan', // now there's only one
      starterTest: {}, // superfluous
      quizResultsData: null, // ?
      payNowButtonsId: ['#payment-request-button-header', '#payment-request-button-billing', '#payment-request-button-floating'],
      showPDFResultsModal: false,
      name: '',
      showFloatingButton: false
    }
  },
  head () {
    return {
      ...this.createSeoTags({
        title: this.$t('quizResults.seo.goalPageTitle', { area: this.goalNameParam }),
        description: this.$t('quizResults.seo.description'),
        url: `https://get-base.com/goal/${this.goal}`,
        link: [
          {
            rel: 'preload',
            as: 'image',
            href: this.getStaticsObject('/quiz-results/quiz_results_specification_0.webp')
          },
          {
            rel: 'preload',
            as: 'image',
            href: this.getStaticsObject('/quiz-results/quiz_results_specification_1.webp')
          },
          {
            rel: 'preload',
            as: 'image',
            href: this.getStaticsObject('/quiz-results/quiz_results_specification_2.webp')
          }
        ]
      })
    }
  },
  computed: {
    ...mapState('product', ['fastTrackTests', 'mainArea', 'planSelected', 'planPrice', 'testMenu', 'fastTrackTestsAreas']),
    ...mapState('quiz', ['goalName']),
    ...mapGetters({
      getPlanPrice: 'product/getPlanPrice',
      getTotalPrice: 'product/getTotalPrice',
      getTestMenuData: 'product/getTestMenuData',
      isBaseImprovementPlanPayUpfront: 'product/isBaseImprovementPlanPayUpfront'
    }),
    goalIdParam () {
      const data = GOALS_URL_PARAMS.get(this.goal)
      return data.goalId
    },
    isPayUpfrontActiveAb () {
      return false
    },
    isPaynowStickyButtonActiveAb () {
      return false
    }
  },
  watch: {
    testMenu () {
      this.updateTestMenu()
    },
    goalIdParam () {
    }
  },
  async created () {
    await this.$store.dispatch('quiz/resetQuizData')
    await this.$store.dispatch('product/resetProducts')

    this.getGoalData()
    this.setArea()

    await this.$store.dispatch('product/selectPlan', this.plan)
    await this.$store.dispatch('product/selectMainArea', this.area)

    this.setPayNow()
  },
  mounted () {
    this.$store.commit('payment/setPaymentType', 'subscription')

    // TODO: Why is this done in mounted vs some other stuff on created?
    this.$store.dispatch('quiz/setGoalName', this.goalNameParam)
    this.$store.dispatch('quiz/setScore', this.score)

    const intercomSettings = {
      email: ''
    }
    this.updateIntercomSettings(intercomSettings)

    window.addEventListener('scroll', () => {
      if (this.$refs.header && this.$refs.header.$el) {
        this.showFloatingButton = !this.isElementInViewport(this.$refs?.header?.$el)
      }
    }, { passive: true })
  },
  methods: {
    getGoalData () {
      // goal, starterTestID, score
      const data = GOALS_URL_PARAMS.get(this.goal)
      this.score = data.score
      if (!this.$route.query.starterTestID) {
        this.starterTestIdParam = data.starterTestId
      } else {
        this.starterTestIdParam = Number(this.$route.query.starterTestID)
      }

      this.goalNameParam = data.goalName
      this.goalName = data.goalName
    },
    trackAddToCart () {
      this.trackFBPixelEvent({
        event: 'AddToCart',
        properties: {
          plan: this.plan,
          area: this.area
        }
      })
      this.trackTikTokEvent({
        event: 'AddToCart',
        properties: {
          content_type: 'product',
          content_id: this.plan,
          content_name: this.plan
        }
      })
      this.trackGAEcommerceAddToCart({ area: this.area, plan: this.plan })
    },
    checkoutLink () {
      return '/checkout-payment'
    },
    async openFastTrackModal () {
      if (this.planSelected) {
        await this.openFastTrackAndCheckout()
      } else if (!this.planSelected) {
        await this.addToCartAndCheckout()
      } else {
        window.location = this.checkoutLink
      }
    },
    async addProductToCart () {
      if (!this.quizResultsData && this.email) {
        this.quizResultsData = await this.getQuizResultsData(this.email.toLowerCase(), this.score) || {}
        const { testForGoal = {} } = this.quizResultsData
        const { testForGoalID: starterTestId = -1, testTitle: starterTest = null } = testForGoal
        this.saveStarterTestId(starterTestId)
        this.saveStarterTest(starterTest)
      }

      await this.$store.dispatch('product/selectMainArea', this.area)
      await this.$store.dispatch('product/selectPlan', this.plan)
    },
    async addToCartAndCheckout () {
      if (this.planSelected && this.planSelected !== 'base-complete-results') {
        this.trackAddToCart()
        this.$root.$emit('bv::show::modal', 'fastTrackModal')
      } else {
        await this.addProductToCart()
      }
    },
    async openFastTrackAndCheckout () {
      if (this.starterTest) {
        await this.$store.dispatch('quiz/setGoalId', this.goalIdParam)
        await this.saveStarterTestId(this.starterTestIdParam)
        await this.saveStarterTest(this.starterTest.testTitle)
        await this.$store.dispatch('product/setFasTrackTests', this.fastTrackTestsAreas[this.area])
      }

      this.$root.$emit('bv::show::modal', 'fastTrackModal')
      this.trackAddToCart()
    },
    setArea () {
      const areaLogic = new Map([
        ['1', 'stress'],
        ['10', 'stress'],
        ['2', 'sleep'],
        ['20', 'sleep'],
        ['3', 'energy'],
        ['30', 'energy'],
        ['4', 'diet'],
        ['40', 'diet'],
        ['5', 'sex-drive'],
        ['50', 'sex-drive']
      ])
      this.area = areaLogic.get(this.score)
    },
    setPayNow () {
      this.$store.commit('product/setPayNowPlan', this.plan)
      this.$store.commit('product/setPayNowArea', this.area)
    },
    saveStarterTestId (starterTestId) {
      this.$store.dispatch('product/setStarterTestId', starterTestId)
    },
    saveStarterTest (starterTest) {
      this.$store.dispatch('product/selectStarterTest', starterTest)
    },
    updateTestMenu () {
      this.starterTest = this.getTestMenuData({ area: this.area, starterTestId: this.starterTestIdParam })
    }
  }
}
